<template>
  <div class="wapper">
    <el-container style="100%">
      <Meeting @getDocumentTypeId="getMeetingId"></Meeting>
      <DocumentType style="border-left: 1px solid #f0f0f0" @getDocumentTypeId="getDocumentTypeId"></DocumentType>
      <el-main style="background: #fff; margin-left: 10px">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-right">
              </div>
              <el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-export"
                    @click="exportExcel()"
                >导出
                </el-button
                >
                <!--                <el-button-->
                <!--                    type="primary"-->
                <!--                    plain-->
                <!--                    icon="el-icon-plus"-->
                <!--                    @click="addSubmit"-->
                <!--                >新增-->
                <!--                </el-button-->
                <!--                >-->&nbsp;&nbsp;
                <el-popover
                    placement="bottom"
                    title="批量导入"
                    width="220"
                    trigger="click"
                >
                  <div>
                    <el-upload
                        class="upload-demo"
                        :action="action"
                        :auto-upload="false"
                        :on-change="uploadChange"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                      <el-button size="small" type="primary"
                      >选择导入模板
                      </el-button
                      >
                    </el-upload>
                    <el-button
                        type="success"
                        @click="download"
                        plain
                        icon="el-icon-download"
                        class="down-template"
                    >下载模板
                    </el-button
                    >
                  </div>
                  <p class="import-text">只能选择 .xls .xlsx 文件</p>
                  <div>
                    <el-button type="success" @click="importData"
                    >新增
                    </el-button
                    >
                    <el-button type="danger" @click="importDataDelete"
                    >删除
                    </el-button
                    >
                  </div>
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-upload2"
                      slot="reference"
                  >导入
                  </el-button
                  >
                </el-popover>
              </el-form-item>
              <div class="uers-left">
                <el-form-item>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.name"
                      placeholder="姓名"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.phone"
                      placeholder="手机"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.company"
                      placeholder="公司"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.groupNo"
                      placeholder="团组"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.code"
                      placeholder="码值"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.idNumber"
                      placeholder="编号"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.rfid"
                      placeholder="rfid"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.remark"
                      placeholder="备注"
                  ></el-input>
                  <el-input
                      style="width: 120px"
                      v-model="searchForm.label"
                      placeholder="标签"
                  ></el-input>
                  <el-date-picker
                      style="width: 185px"
                      v-model="searchForm.startDate"
                      type="datetime"
                      placeholder="开始日期"
                  ></el-date-picker>
                  <el-date-picker
                      style="width: 185px"
                      v-model="searchForm.endDate"
                      type="datetime"
                      placeholder="结束日期"
                  ></el-date-picker>
                  <el-select v-model="searchForm.isPrint">
                    <el-option value="-1" label="全部打印"></el-option>
                    <el-option value="0" label="未打印"></el-option>
                    <el-option value="1" label="已打印"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.isMake">
                    <el-option value="-1" label="全部入库"></el-option>
                    <el-option value="0" label="未入库"></el-option>
                    <el-option value="1" label="已入库"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.isRepeat">
                    <el-option value="0" label="全部数据"></el-option>
                    <el-option value="1" label="姓名重复"></el-option>
                    <el-option value="2" label="手机号重复"></el-option>
                    <el-option value="3" label="身份证重复"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.isRfid">
                    <el-option value="-1" label="全部卡"></el-option>
                    <el-option value="0" label="未写卡"></el-option>
                    <el-option value="1" label="已写卡"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.isAvatar">
                    <el-option value="-1" label="全部头像"></el-option>
                    <el-option value="0" label="没有头像"></el-option>
                    <el-option value="1" label="已有头像"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.zd">
                    <el-option value="-" label="全部重点状态"></el-option>
                    <el-option value="" label="未验证"></el-option>
                    <el-option value="0" label="成功"></el-option>
                    <el-option value="-1" label="失败"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.status">
                    <el-option value="-" label="全部三要素状态"></el-option>
                    <el-option value="" label="未验证"></el-option>
                    <el-option value="0" label="成功"></el-option>
                    <el-option value="-1" label="失败"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.status2">
                    <el-option value="-" label="全部二要素状态"></el-option>
                    <el-option value="" label="未验证"></el-option>
                    <el-option value="0" label="成功"></el-option>
                    <el-option value="-1" label="失败"></el-option>
                  </el-select>
                  <el-select v-model="searchForm.disabled">
                    <el-option value="-1" label="全部公安审核"></el-option>
                    <el-option value="0" label="公安未审核"></el-option>
                    <el-option value="1" label="公安已审核"></el-option>
                    <el-option value="2" label="审核不通过"></el-option>
                    <el-option value="3" label="无效身份证"></el-option>
                  </el-select>&nbsp;&nbsp;
                  <el-button
                      type="primary"
                      icon="el-icon-search"
                      @click="searchSubmit"
                  >搜索
                  </el-button
                  >
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
            >
              <el-table-column label="操作" width="60" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  width="100"
                  label="姓名/手机号"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.phone }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="code"
                  width="120"
                  label="码值/编号"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.code }}</p>
                  <p>{{ scope.row.idNumber }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="idCard"
                  width="150"
                  label="身份证/rfid"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.idCard }}</p>
                  <p>{{ scope.row.rfid }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="avatar"
                  width="60"
                  label="头像"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.avatar"
                        :preview-src-list="[scope.row.avatar]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="company"
                  label="公司/团组/职位"
                  align="center"
                  width="120"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.company }}</p>
                  <p>{{ scope.row.groupNo }}</p>
                  <p>{{ scope.row.position }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="typeName"
                  width="90"
                  label="证件类型"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.typeName }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="80"
                  prop="isPrint"
                  label="状态"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.isPrint ? "已打印" : "未打印" }}</p>
                  <p>{{ scope.row.device }}</p>
                  <p>{{ scope.row.isMake ? "已入库" : "未入库" }}：{{ scope.row.makeDate }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="200"
                  prop="printDate"
                  label="创建时间"
                  align="left"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.createDate }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditPapersManage
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditPapersManage>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import {Loading} from "element-ui";
import EditPapersManage from "../../../components/ticketing/certificate/EditPapersManage";
import DocumentType from "../../../components/ticketing/certificate/docuType/DocumentType";
import DeleteDialog from "../../../components/public/DeleteConfim";
import Meeting from "@/components/ticketing/meeting/meeting";

export default {
  data() {
    return {
      fileList: [],
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      roles: localStorage.getItem("roles"),
      gb: window.location.hostname.indexOf("gb") > -1,
      searchForm: {
        status: "-",
        status2: "-",
        zd: "-",
        groupNo: "",
        name: "",
        code: "",
        phone: "",
        idNumber: "",
        meetingId: 0,
        documentTypeId: 0,
        isRepeat: "0",
        isPrint: "-1",
        isRfid: "-1",
        isMake: "-1",
        disabled: "-1",
        company: "",
        rfid: "",
        isAvatar: "-1",
        remark: "",
        label: "",
        endDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
        startDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
                new Date(new Date().getFullYear().toString()))
        ),
      },
      meetingId: null,
      documentTypeId: null,
      editData: {},
      listShow: true,
      delVisible: false,
      documentMeetingId: "",
      editShow: false,
      dataList: [],
      dataType: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      action: localStorage.getItem("url") + "/Upload/File?eId=" + localStorage.getItem("project_Id"),
      attr: [],
      ids: [],
    };
  },
  mounted() {
    if (document.documentElement.clientHeight < 900) {
      this.pagesize = 5;
    }
    this.getData();
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
  },
  methods: {
    getDocumentTypeId(val) {
      this.documentTypeId = val;
      this.searchForm.documentTypeId = val;
      this.getData();
    },
    getMeetingId(val) {
      this.meetingId = val;
      this.searchForm.meetingId = val;
      this.getData();
    },
    effective() {
      this.$confirm("是否同步证件的有效时间？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      }).then(() => {
        this.$axios.put(`/DocumentMeeting/effective/${this.projectId}`)
            .then(res => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message({type: "success", message: "同步成功!"});
                //刷新
                this.getData();
              }
            });
      })
          .catch(() => {
            this.$message({type: "info", message: "已取消操作"});
          });
    },
    effectiveClear() {
      this.$confirm("是否清空证件有效时间？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      }).then(() => {
        this.$axios.put(`/DocumentMeeting/effectiveClear/${this.projectId}`)
            .then(res => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message({type: "success", message: "清空成功!"});
                //刷新
                this.getData();
              }
            });
      })
          .catch(() => {
            this.$message({type: "info", message: "已取消操作"});
          });
    },
    //  文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.$message.warning("文件已移除");
    },
    handleChange(file, fileList) {
      this.fileList = this.fileList.slice(-1);
    },
    handleExceed() {
      //提示最多只能上传1个
      this.$message.warning("最多上传1个文件！");
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    upload(file, fileList) {
      this.file = event.currentTarget.files[0];
      const limitSize = 1024 * 1024 * 100;
      if (this.file.size > limitSize) {
        alert("文件大小不能超过100MB");
      }
      let formData = new FormData();
      formData.append('file', this.file);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios.post("/Upload/File?eId=" + this.projectId, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(res => {
        if (res.data.hasError == false) {
          this.$message.success(res.data.message)
        } else {
          this.$message.error('操作失败')
        }
        loading.close();
        this.fileList = this.fileList.slice(-1);
      }).catch((e) => {
        this.$message.error("操作失败");
        loading.close();
      });
    },
    exportExcel() {
      var search = {
        projectId: this.projectId,
        name: this.searchForm.name,
        code: this.searchForm.code,
        isPrint: this.searchForm.isPrint,
        isAvatar: this.searchForm.isAvatar,
        idNumber: this.searchForm.idNumber,
        company: this.searchForm.company,
        groupNo: this.searchForm.groupNo,
        rfid: this.searchForm.rfid,
        documentTypeId: this.searchForm.documentTypeId,
        pageIndex: 0,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        isRfid: this.searchForm.isRfid,
        pageSize: this.total,
        remark: this.searchForm.remark,
        phone: this.searchForm.phone,
        status: this.searchForm.status,
        status2: this.searchForm.status2,
        zd: this.searchForm.zd,
        verify: this.searchForm.verify,
        disabled: this.searchForm.disabled,
        isMake: this.searchForm.isMake,
        label: this.searchForm.label,
        meetingId: this.searchForm.meetingId,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/DocumentMeeting/Export`, search)
          .then((res) => {
            loading.close();
            if (res.data.data) {
              window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出证件.xlsx');
            } else {
              this.$message.error("导出失败");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出失败");
          });
    },
    downLoad(url, fileName) {
      return fetch(url).then((res) => {
        res.fetch(url).then((blob) => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        });
      });
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          } // outdata就是你想要的东西 excel导入的数据
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
          let ar = [];
          let codes = [];
          outdata.map((v) => {
            let obj = {};
            obj.documentId = v.ID;
            obj.name = v.名称;
            obj.phone = v.手机号;
            obj.code = v.二维码值;
            obj.idNumber = v.证件编号;
            obj.avatar = v.头像;
            obj.remark = v.备注;
            obj.company = v.公司;
            obj.position = v.职务;
            obj.idCard = v.身份证号;
            obj.sex = v.性别;
            obj.rfid = v.rfid;
            obj.isPrint = false;
            obj.groupNo = v.团组;
            obj.address = v.地址;
            obj.area = v.地区;
            obj.effectiveStart = v.有效时间开始;
            obj.effectiveEnd = v.有效时间结束;
            obj.companyEn = v.英文公司;
            obj.nameEn = v.英文名称;
            obj.positionEn = v.英文职务;
            obj.addressEn = v.英文地址;
            obj.status = v.三要素状态;
            obj.market = v.参与论坛;
            obj.status2 = v.二要素状态;
            obj.zd = v.ZD状态;
            obj.typeName = v.证件类型;
            obj.visit = v.座位号;
            obj.role = v.参会身份;
            obj.hotel = v.酒店;
            obj.roomtype = v.房间类型;
            obj.roomNo = v.房间号;
            obj.booth = v.展位;
            obj.departureTime = v.离店类型;
            obj.checkInTime = v.入住时间;
            obj.remark1 = v.备注1;
            obj.remark2 = v.备注2;
            obj.remark3 = v.备注3;
            obj.remark4 = v.备注4;
            obj.remark5 = v.备注5;
            ar.push(obj);
            if (v.二维码值) {
              codes.push(v.二维码值);
            }
          });
          localStorage.setItem("attr", JSON.stringify(ar));
          localStorage.setItem("ids", JSON.stringify(codes));
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    download() {
      let url = localStorage.getItem("url");
      window.open(url.replace("/api", "/") + "/data/会议证件模板.xlsx");
    },
    importData() {
      if (this.meetingId) {
        this.ids = JSON.parse(localStorage.getItem("ids"));
        if (this.ids && this.ids.length > 0) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let url = "/DocumentMeeting/AddList/" + this.meetingId;

          this.$axios
              .put(url, this.ids)
              .then((res) => {
                if (res.data.hasError == false) {
                  loading.close();
                  localStorage.setItem("attr", null);
                  this.getData();
                  this.$message.success(res.data.message);
                } else {
                  this.$message.error(res.data.message);
                  loading.close();
                }
              })
              .catch(function () {
                loading.close();
              });
        } else {
          this.$message.error("没有可上传的数据");
        }
      } else {
        this.$alert("请选择会议")
      }
    },
    importDataDelete() {
      this.ids = JSON.parse(localStorage.getItem("ids"));
      if (this.ids && this.ids.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
            .put("/DocumentMeeting/BatchDelete/" + this.meetingId, this.ids)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                localStorage.setItem("attr", null);
                this.getData();
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }

    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.getSearch();
      this.attr = [];
    },
    getSearch() {
      var search = {
        projectId: this.projectId,
        name: this.searchForm.name,
        code: this.searchForm.code,
        isPrint: this.searchForm.isPrint,
        isRepeat: this.searchForm.isRepeat,
        isRfid: this.searchForm.isRfid,
        isAvatar: this.searchForm.isAvatar,
        idNumber: this.searchForm.idNumber,
        company: this.searchForm.company,
        remark: this.searchForm.remark,
        groupNo: this.searchForm.groupNo,
        rfid: this.searchForm.rfid,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        documentTypeId: this.searchForm.documentTypeId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        phone: this.searchForm.phone,
        status: this.searchForm.status,
        status2: this.searchForm.status2,
        zd: this.searchForm.zd,
        verify: this.searchForm.verify,
        disabled: this.searchForm.disabled,
        isMake: this.searchForm.isMake,
        label: this.searchForm.label,
        meetingId: this.searchForm.meetingId
      };
      this.$axios.post("/DocumentMeeting/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    addSubmit() {
      this.documentMeetingId = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.documentMeetingId = row.documentMeetingId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/DocumentMeeting/${this.documentMeetingId}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    handleCloseVisible() {
      this.documentMeetingId = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditPapersManage,
    DocumentType,
    DeleteDialog,
    Meeting
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  height: 100%;
  margin-left: 10px;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin-bottom: 20px;
}

.btn-r {
  margin-right: 20px;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}

.el-dialog {
  height: auto;
}
</style>